module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousSalesView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": ""
    }
  }, [_c('h2', [_vm._v("AMS Filing")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Master B/L Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "linerBLNumber",
      "name": "linerBLNumber",
      "disabled": _vm.amsMainModel.blType == 'liner'
    },
    model: {
      value: (_vm.amsMainModel.blNumber),
      callback: function($$v) {
        _vm.$set(_vm.amsMainModel, "blNumber", $$v)
      },
      expression: "amsMainModel.blNumber"
    }
  })], 1), _vm._v(" "), (!_vm.amsMainModel.blNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.erroramsMainModel.blNumber))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload B/L")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "uploadMasterBL",
      "id": "uploadMasterBL",
      "multiple": "",
      "disabled": _vm.amsMainModel.blType == 'liner'
    },
    on: {
      "selected": _vm.onFileChangelinerBL
    },
    model: {
      value: (_vm.amsMainModel.uploadMasterBL),
      callback: function($$v) {
        _vm.$set(_vm.amsMainModel, "uploadMasterBL", $$v)
      },
      expression: "amsMainModel.uploadMasterBL"
    }
  })], 1), _vm._v(" "), (!_vm.amsMainModel.uploadMasterBL) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.erroramsMainModel.uploadMasterBL))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.uploadBookingStatus.length > 0 && _vm.amsMainModel.blType == 'liner') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _vm._l((_vm.uploadBookingStatus), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "15"
      }
    }, [_c('a', {
      attrs: {
        "href": (this.docURL) + "/LinerBLCon/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.uploadBookingStatus.length > 0 && _vm.amsMainModel.blType == 'house' && _vm.amsMainModel.amsMainId != '') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _vm._l((_vm.uploadBookingStatus), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "15"
      }
    }, [_c('a', {
      attrs: {
        "href": (this.docURL) + "/SeaAwsBL/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "amsFiling"
    }
  }, [_vm._v(_vm._s((this.amsMainModel.blType == 'liner') ? '(Liner-BL)' : '(House-BL)') + " AMS Filing To be Done")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.blTypeList,
      "option-value": "blTypeVal",
      "option-text": "blTypeTxt",
      "placeholder": "Select AMS Filing ",
      "isDisabled": _vm.amsTableArry.length > 0
    },
    model: {
      value: (_vm.amsMainModel.amsFiling),
      callback: function($$v) {
        _vm.$set(_vm.amsMainModel, "amsFiling", $$v)
      },
      expression: "amsMainModel.amsFiling"
    }
  }), _vm._v(" "), (!_vm.amsMainModel.amsFiling) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.erroramsMainModel.amsFiling))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.amsMainModel.portLocationType == 'USA') ? _c('md-layout', {
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "my-test5",
      "name": "my-test5",
      "md-value": "checked"
    },
    model: {
      value: (_vm.amsMainModel.isCheckUSA),
      callback: function($$v) {
        _vm.$set(_vm.amsMainModel, "isCheckUSA", $$v)
      },
      expression: "amsMainModel.isCheckUSA"
    }
  }, [_vm._v("AMS Against HBL (PRIDEL Fling)")])], 1) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.amsMainModel.amsFiling == 'Yes') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), (_vm.amsMainModel.amsFiling == 'Yes' || _vm.amsFiligModal.amsId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('h3', [_c('u', [_vm._v("ADVANCE CARGO DECLARATION(ACD)")])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.amsMainModel.amsFiling == 'Yes' || _vm.amsFiligModal.amsId != '') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [(_vm.amsFiligModal.amsId == '') ? _c('label', {
    attrs: {
      "for": "fclConsoMultipleClientId"
    }
  }, [_vm._v("Client Name")]) : _vm._e(), _vm._v(" "), (_vm.amsFiligModal.amsId == '') ? _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "fclConsoMultipleClientId",
      "option-value": "fclConsoMultipleClientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.amsFiligModal.fclConsoMultipleClientId),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "fclConsoMultipleClientId", $$v)
      },
      expression: "amsFiligModal.fclConsoMultipleClientId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "fclConsoMultipleClientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.amsFiligModal.clientName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "clientName", $$v)
      },
      expression: "amsFiligModal.clientName"
    }
  })], 1), _vm._v(" "), (!_vm.amsFiligModal.fclConsoMultipleClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorconFclBLNonUsId))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsMainModel.amsFiling == 'Yes' && _vm.amsFiligModal.fclConsoMultipleClientId != '') ? _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vesselName",
      "name": "vesselName"
    },
    model: {
      value: (_vm.amsFiligModal.vesselName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "vesselName", $$v)
      },
      expression: "amsFiligModal.vesselName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place of Origin")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "placeOrigin",
      "name": "placeOrigin"
    },
    model: {
      value: (_vm.amsFiligModal.placeOrigin),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "placeOrigin", $$v)
      },
      expression: "amsFiligModal.placeOrigin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port of Loading")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "loadingPort",
      "name": "loadingPort"
    },
    model: {
      value: (_vm.amsFiligModal.loadingPort),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "loadingPort", $$v)
      },
      expression: "amsFiligModal.loadingPort"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port of Discharge")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "dischargePort",
      "name": "dischargePort"
    },
    model: {
      value: (_vm.amsFiligModal.dischargePort),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "dischargePort", $$v)
      },
      expression: "amsFiligModal.dischargePort"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Delivery Place With ZIP Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "finalDeliveryWithZip",
      "name": "finalDeliveryWithZip"
    },
    model: {
      value: (_vm.amsFiligModal.finalDeliveryWithZip),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "finalDeliveryWithZip", $$v)
      },
      expression: "amsFiligModal.finalDeliveryWithZip"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Actual Shipper Address with Ctc")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.shipperAddrWithCtc),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "shipperAddrWithCtc", $$v)
      },
      expression: "amsFiligModal.shipperAddrWithCtc"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', [_vm._v("Consignee Name Address with Tel.& FAX No.")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.ConsigneeNameAddrs),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "ConsigneeNameAddrs", $$v)
      },
      expression: "amsFiligModal.ConsigneeNameAddrs"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Container No.")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "containerNo", $$v)
      },
      expression: "amsFiligModal.containerNo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Seal No")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.sealNo),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "sealNo", $$v)
      },
      expression: "amsFiligModal.sealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Cargo Description With 6 Digit Harmonized Code with No. Of Cartons / Pellets")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.cargoDescription),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "cargoDescription", $$v)
      },
      expression: "amsFiligModal.cargoDescription"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Cargo Gross Weight")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.cargoGrossWeight),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "cargoGrossWeight", $$v)
      },
      expression: "amsFiligModal.cargoGrossWeight"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Cargo Net Weight")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.cargoNetWeight),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "cargoNetWeight", $$v)
      },
      expression: "amsFiligModal.cargoNetWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('label', [_vm._v("Declaration")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "1100px !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.declaration),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "declaration", $$v)
      },
      expression: "amsFiligModal.declaration"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("For")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "declarationFor",
      "name": "declarationFor"
    },
    model: {
      value: (_vm.amsFiligModal.declarationFor),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "declarationFor", $$v)
      },
      expression: "amsFiligModal.declarationFor"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "declarationDate",
      "name": "declarationDate"
    },
    model: {
      value: (_vm.amsFiligModal.declarationDate),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "declarationDate", $$v)
      },
      expression: "amsFiligModal.declarationDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsMainModel.blType == 'liner') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "isIsfFiling"
    }
  }, [_vm._v(_vm._s((this.amsMainModel.blType == 'liner' ? '(Liner-BL)' : this.amsMainModel.blType)) + " ISF Filing To be Done")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.blTypeListISF,
      "option-value": "blTypeIsfVal",
      "option-text": "blTypeIsfTxt",
      "placeholder": "Select ISF Filing "
    },
    model: {
      value: (_vm.amsMainModel.isIsfFiling),
      callback: function($$v) {
        _vm.$set(_vm.amsMainModel, "isIsfFiling", $$v)
      },
      expression: "amsMainModel.isIsfFiling"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsMainModel.isIsfFiling == 'Yes') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.amsMainModel.amsFiling == 'Yes' && _vm.clientList.length > 0 || _vm.amsFiligModal.amsId != '') ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoaderSubmit"
    },
    on: {
      "click": function($event) {
        _vm.addAms('')
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSubmit"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (_vm.amsTableArry.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("AMS Details")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "clientSB"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Print")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.amsTableArry), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEditAms(item)
        }
      }
    }, [_vm._v(_vm._s(item.clientName))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.Print(item.uploadACDCON)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1)], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }), _vm._v(" "), ((_vm.amsMainModel.portLocationType == 'USA' && _vm.amsMainModel.blType == 'house') || _vm.amsMainModel.isIsfFiling == 'Yes') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoaderIFS"
    },
    on: {
      "click": function($event) {
        _vm.addAms('fdf')
      }
    }
  }, [_vm._v("Proceed To IFS Form")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderIFS"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopBL",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.oncloseBL
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopError",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f781439a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ffExportCon/amsFilling.vue
// module id = 2915
// module chunks = 0